var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7345 0.00127626L45.542 7.68235L39.6953 15.4146C51.9067 16.0309 61.6175 26.1275 61.6175 38.4903C61.6175 42.2576 60.7098 45.8112 59.1111 48.9543L62.8888 57.8949L72.449 56.7048C75.3661 51.2805 77.0218 45.0789 77.0218 38.4897C77.0218 17.6305 60.4373 0.647676 39.7347 0.000488281L39.7345 0.00127626Z",
    fill: "#009EE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9382 49.0065C16.3224 45.8511 15.4043 42.2783 15.4043 38.4907C15.4043 26.143 25.0903 16.0588 37.2779 15.4166L43.1272 7.68108L37.3179 0C16.5995 0.628744 -0.000976562 17.6199 -0.000976562 38.4892C-0.000976562 45.0687 1.65079 51.2619 4.56002 56.6792L8.30884 47.8067L17.9382 49.0065Z",
    fill: "#8665CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9043 51.0471C53.7855 57.3935 46.6406 61.5962 38.5105 61.5962C30.4031 61.5962 23.2746 57.4163 19.1519 51.0976L9.51768 49.8977L5.76953 58.7682C12.562 69.7117 24.6855 77.0001 38.5112 77.0001C52.3264 77.0001 64.4406 69.7243 71.2361 58.7967L61.6805 59.9867L57.9043 51.0471Z",
    fill: "#3134DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.a6cde12923c8afe43ef87f73e08a0ec8.svg";
export { ForwardRef as ReactComponent };